import type { GetActivitiesSectionsQuery } from '../../../lesson-builder.graphql.generated';
import {
  ACTIVITIES_ANSWER_IMAGE_TYPE,
  ACTIVITIES_ANSWER_TEXT,
  CONTENT_IMAGE,
  ImageType,
} from 'global/constants';
import { removeTypenameFromObject } from 'approot/shared/logic/remove-typename';
import { getImageAnswer } from './get-image-answer';
import { getRichtextAnswer } from './get-richtext-answer';
import type { Pluck } from 'lib/gql/pluck';

export function getSuggestedAnswerItemPayload(
  answer: Pluck<
    Extract<
      Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
      { __typename: 'ActivitiesResponseComponent' }
    >,
    'suggestedAnswerProperties.suggestedAnswers'
  >
) {
  const imageAnswer =
    answer.answerType === ACTIVITIES_ANSWER_IMAGE_TYPE
      ? getImageAnswer(answer)
      : null;
  return {
    uuid: answer.uuid,
    answer: {
      answerType: answer.answerType,
      richtext:
        answer.answerType === ACTIVITIES_ANSWER_TEXT
          ? getRichtextAnswer(answer)
          : null,
      image: imageAnswer
        ? {
            fileName: imageAnswer.fileName,
            imageType: CONTENT_IMAGE as ImageType,
            key: imageAnswer.key,
            alt: imageAnswer.alt,
          }
        : null,
    },
    answerReferences: answer.answerReferences
      ? removeTypenameFromObject(answer.answerReferences)
      : null,
  };
}
